import { render, staticRenderFns } from "./pallet.vue?vue&type=template&id=6b92871a&scoped=true&"
import script from "./pallet.vue?vue&type=script&lang=js&"
export * from "./pallet.vue?vue&type=script&lang=js&"
import style0 from "./pallet.vue?vue&type=style&index=0&id=6b92871a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b92871a",
  null
  
)

export default component.exports